import React from 'react';
import { useFirestoreDocumentMutation } from '@react-query-firebase/firestore';
import { doc } from 'firebase/firestore';
import toast from 'react-hot-toast';

import { PuzzleStatus } from '../../../../../types';
import { firestore } from '../../../../../services/Firebase';
import { Button, Splash } from '../../../../../shared/Components';
import { strings } from '../../../../../strings';

import { PuzzleProps } from './DeletePuzzleButton';

export const RestorePuzzleButton = (props: PuzzleProps) => {
  const puzzle = doc(firestore, 'puzzles', props.id);
  const { mutate } = useFirestoreDocumentMutation(
    puzzle,
    {
      merge: true,
    },
    {
      onSuccess() {
        toast.success(strings.successfullyRestoredCollection);
        props.onCompleted?.();
      },
      onError() {
        toast.error(strings.toastNotificationSomethingWrong);
      },
      onMutate() {
        return <Splash />;
      },
    },
  );

  const restorePuzzle = () => {
    mutate({
      status: PuzzleStatus.APPROVED,
      isSubmited: true,
    });
  };

  return (
    <Button onClick={restorePuzzle} variant="link">
      {strings.restore}
    </Button>
  );
};
